/**
 * WISHLIST DELETE
 * 
 * module de gestion des suppression de wishlist
 * via une popin dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
import { dialog } from "../../../../components/dialog";
const utils = require('../utils').default;

const WLDelete = (() => {
    const DOM_DELETE = 'popin-wishlist-delete';
    const DOM_DELETE_SHOW = `[data-js-dialog-open="${DOM_DELETE}"`;
    const DOM_DELETE_POPIN = `[data-js-dialog-id="${DOM_DELETE}"]`;
    const DOM_DELETE_SUBMIT = `${DOM_DELETE_POPIN} .js-delete-wishlist`;
    const DOM_DELETE_ERROR = `${DOM_DELETE_POPIN} .js-form-error`;

    const SUCCESS_LIST_DELETE = 'Votre liste a bien été supprimé.';

    /**
     * POPIN OPEN (func)
     * 
     * Ouverture de la popin creation d'adresse
     */
    const popinOpen = (event) => {
        updateTemplates(event);
        if ($(DOM_DELETE_SUBMIT).data('wishlist-id') === utils.slug(window.WL.getDefaultListName())) {
            $(DOM_DELETE_SUBMIT).attr('disabled', 'disabled');
            $(DOM_DELETE_ERROR).attr('aria-hidden', false);
        } else {
            $(DOM_DELETE_SUBMIT).attr('disabled', false);
            $(DOM_DELETE_ERROR).attr('aria-hidden', true);
        }
        $(DOM_DELETE_SUBMIT).off().on('click', deleteList);
    };
    /**
     * DELETE LIST
     * 
     * @param {event} event 
     */
    const deleteList = (event) => {
        event.preventDefault();
        let listId = $(DOM_DELETE_SUBMIT).data('wishlist-id');
        /**
         * Generation du tracker 
         * TRACKER_WISHLIST_PRODUCTS_REMOVE_CART
         */
        window.WL.getWishlistFlattenProductsFromList(listId).then((products) => {
            utils.dispatchCustomEvent('TRACKER_WISHLIST_PRODUCTS_REMOVE_FROM_CART', {
                listLabel: listId,
                listCategory: utils.getContext(),
                products
            });
            window.WL.deleteWishlist(listId);
        })
        utils.dispatchCustomEvent('ANIMATION_LIST_REMOVE', {listId});
        utils.dispatchCustomEvent('WISHLIST_HAS_CHANGED', {event: `List deleted : ${listId}`});
        utils.dispatchCustomEvent('NOTIFICATION_DEFAULT', {content: SUCCESS_LIST_DELETE, type: 'success'});
        utils.dispatchCustomEvent('TRACKERS_WISHLIST_DELETE_LIST', {name: listId});
        dialog.close();
    };
    /**
     * UPDATE TEMPLATE (func)
     * 
     * Mise à jour du template de la popin 
     * de suppression d'adresse
     */
    const updateTemplates = (event) => {
        let data = {
            name: $(event.currentTarget).data('wishlist-name'),
            id: $(event.currentTarget).data('wishlist-id'),
        };
        utils.dispatchCustomEvent('TEMPLATE_POPIN_UPDATE', {popinTargetID: DOM_DELETE, data});
    };
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('WL DELETE', 'initialisation');   
        $(DOM_DELETE_SHOW).off().on('click', popinOpen);
    }
    return {init}
})();
export default WLDelete;